import { Button, Flex, ModalBody, ModalContent, ModalFooter, ModalHeader, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ControllableModal } from 'components/Modal';

interface ITermsAndConditionModal {
  isOpen: boolean;
  onClose: () => void;
  submitBtnIsLoading?: boolean;
  onAcceptTAndC: () => void;
}

const TermsAndConditionModal: React.FC<ITermsAndConditionModal> = ({
  isOpen,
  onClose,
  submitBtnIsLoading = false,
  onAcceptTAndC,
}) => {
  const { t } = useTranslation(['accountBilling', 'common']);

  return (
    <ControllableModal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        <ModalHeader>{t('accountBilling:billingTAndC.heading')}</ModalHeader>
        <ModalBody>
          <Text>
            {t('accountBilling:paymentsWillAutorenewEachMonthOrYearDependingOnYourPlanYouMayCancelAtAnyTime')}
            <Text as="span" fontWeight={700}>
              {' '}
              {t('accountBilling:paymentsAreNotRefundable')}
            </Text>
          </Text>
        </ModalBody>
        <ModalFooter>
          <Flex justifyContent="flex-end" alignItems="center" gridGap={3}>
            <Button onClick={onClose} colorScheme="secondary" variant="ghost">
              {t('common:cancel')}
            </Button>
            <Button onClick={onAcceptTAndC} colorScheme="secondary" isLoading={submitBtnIsLoading}>
              {t('accountBilling:upgradeNow')}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </ControllableModal>
  );
};

export default TermsAndConditionModal;
